<template>
  <div style="width:100%;height:100%;position: absolute;left:0;top:0;">
    <div id="shangquanfenbu"></div>
    <div v-show="infoBox" ref="infoBox" class="info-box">
      <h2>{{ infoBox.name }}</h2>
      <p v-for="(item, index) in infoBox.data" :key="index">
        {{ item.name + ": " + item.value }}
      </p>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  name: 'ShangquanFenbu',
  components: {},
  props: {
    colorList: {
      type: Array,
      default() {
        return [
          '#0080ff',
          '#00cdff',
          '#00d8ae',
          '#a1e058',
          '#ffe05f',
          '#d97b81',
          '#ffb981',
          '#ffb981',
          '#ffb981',
          '#ffb981',
          '#ffb981'
        ]
      }
    },
    mapData: {
      type: Object
    }
  },
  data() {
    return {
      map: null,
      infoBox: ''
    }
  },
  mounted() {
    this.map = new AMap.Map('shangquanfenbu', {
      mapStyle: 'amap://styles/5411bd4e683c3b6f54012fe05ad53f5a',
      dragEnable: false
    })

    // 遍历增加标记
    for (let i = 0; i < this.mapData.pointData.length; i++) {
      var circle = new AMap.Circle({
        map: this.map,
        center: this.mapData.pointData[i].position, //设置线覆盖物路径
        radius: this.mapData.pointData[i].data[0].value + 5000,
        strokeColor: this.colorList[i], //边框线颜色
        strokeOpacity: 0.8, //边框线透明度
        strokeWeight: 2, //边框线宽
        fillColor: this.colorList[i], //填充色
        fillOpacity: 0.4, //填充透明度
        index: i
      })
      circle.on('mouseover', e => {
        var index = e.target.B.index
        this.$refs.infoBox.style.left = e.pixel.x + "px";
        this.$refs.infoBox.style.top = e.pixel.y + "px";
        this.infoBox = this.mapData.pointData[index]
      })
      circle.on('mouseout', e => {
        this.infoBox = ''
      })
    }
    
    this.map.setFitView()
  },
  methods: {}
}
</script>

<style scoped lang="less">
#shangquanfenbu {
  width: 100%;
  height: 100%;
}
.info-box {
  width: 150px;
  padding: 20px;
  border: 1px solid #36a2f9;
  background: rgba(10, 30, 60, 0.8);
  position: absolute;
  left: 0;
  top: 0;
  text-align: left;
}
</style>
